<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <navbar>
      <template v-slot:navbarname>
        <b-link
            :to="{name:'StockAddGroup'}"
            class="btn btn-primary btn-round">+ Add Group
        </b-link>
      </template>
    </navbar>
    <!--END Navbar-->

    <template v-if="productsEndSoon.length > 0">
      <h3 class="mb-0">Der Lagerbestand dieser Produkte geht zur Neige</h3>
      <carousel :responsive="{0:{items:1,nav:false},600:{items:2,nav:false},1000:{items:4,nav:false}}" :items="4"
                :nav="myFalse" :margin="margin">
        <stock-item :stockItem="item" v-for="(item,index) in productsEndSoon" :key="index">1</stock-item>
      </carousel>
      <!--END END Soon-->
    </template>


    <template v-if="stockGroups.length > 0">
      <h3 class="mb-0">Sammlung von Produkten</h3>
      <carousel :responsive="{0:{items:1,nav:false},600:{items:2,nav:false},1000:{items:4,nav:false}}" :items="4"
                :nav="myFalse" :margin="margin">
        <b-card v-for="(item,index) in stockGroups" :key="index">
          <b-img src="/images/storefront.png"></b-img>
          <h4 class="mt-3 font-weight-bold">{{ item.title }}</h4>

          <b-list-group>
            <b-list-group-item class="d-flex justify-content-between align-items-center px-0">
              inventar
              <span>{{ item.amount }}</span>
            </b-list-group-item>

            <b-list-group-item class="d-flex justify-content-between align-items-center px-0">
              products
              <span>{{ item.products }}</span>
            </b-list-group-item>

          </b-list-group>

          <div class="text-center">
            <b-link
                :to="{name:'DetailsGroup',params:{'groupid':item.id}}"
                class="btn btn-info btn-round">{{ $t('detailsTitle') }}
            </b-link>
          </div>
        </b-card>
      </carousel>
      <!--END Stock Groups-->
    </template>


    <b-row>

      <b-col cols="12" md="3">
        <b-card class="sticky-top">
          <div class="content-filter">
            <b-form-group
                class="font-weight-bold"
                label="SEARCH IN PRODUCTS">
              <b-input v-model="searchInput" placeholder="search..."></b-input>
            </b-form-group>
            <b-form-group
                class="font-weight-bold"
                label="CATEGORIES">
              <b-input class="mb-3" v-model="searchInputCategory" placeholder="search in categories..."></b-input>
              <b-form-checkbox-group
                  id="checkbox-group-4"
                  :options="getCategoriesSearch"
                  v-model="filter.categoryIds"
                  @change="onSelectFilter"
                  value-field="category_id"
                  text-field="category_title"
                  name="orderStatus"
                  stacked
              ></b-form-checkbox-group>
            </b-form-group>
          </div>
        </b-card>
      </b-col>
      <!--END Filter-->


      <template v-if="products.length > 0">
        <b-col cols="12" md="9">
          <b-row>
            <b-col cols="12" md="4" v-for="(item,index) in products" :key="index">
              <stock-item :stockItem="item"></stock-item>
            </b-col>
          </b-row>
          <infinite-loading :identifier="infiniteId" :distance="1"
                            @infinite="getStocks"></infinite-loading>
        </b-col>
      </template>
    </b-row>
    <!--END Products-->


  </div>
</template>

<script>
import Navbar from "../Partials/Navbar";
import Http from '../../Services/HttpService/HttpService'
import Notification from '../../Services/Notification/Nottification'
import carousel from 'vue-owl-carousel'
import StockItem from "./Components/StockItem";
import 'vue-select/dist/vue-select.css';


export default {
  name: "Index",
  components: {
    StockItem,
    Navbar,
    carousel
  },
  data() {
    return {
      page: 1,
      infiniteId: +new Date(),
      playSpeed: 5,
      margin: 15,
      myFalse: false,
      myTrue: false,
      productsEndSoon: [],
      stockGroups: [],
      products: [],
      filter: {
        categories: [],
        categoryIds: [],
      },
      searchInput: null,
      searchInputCategory: null,
    }
  },
  computed:{
    getCategoriesSearch() {
      if (this.searchInputCategory === null) {
        return this.filter.categories;
      }

      return this.filter.categories.filter(item => {
        return item.category_title.toLowerCase().match(this.searchInputCategory.toLowerCase())
      })
    },
  },
  watch: {
    searchInput(after, before) {
      this.onSelectFilter();
    }
  },
  methods: {
    onSelectFilter() {
      this.page = 1;
      this.products = [];
      this.infiniteId += 1;
      this.getStocks();
      this.$router.push({
        name: 'Stock',
        query: {
          categoryIds: this.filter.categoryIds,
        }
      })
    },
    getStockGroups() {
      this.$Progress.start();
      Http.get(Http.apiurlV2() + 'stock/group/index')
          .then(response => {
            this.$Progress.finish();
            if (response.data.status_code === Http.ok()) {
              this.stockGroups = response.data.data;
            }
          })
          .catch(error => {
            this.$Progress.finish();
          })
    },
    getStocks($state) {
      this.$Progress.start();
      Http.post(Http.apiurlV2() + 'stock/index?page=' + this.page, {
        categoryIds: this.filter.categoryIds,
        searchInput: this.searchInput
      })
          .then(response => {
            if (response.data.status_code === Http.ok()) {

              this.$Progress.finish();

              this.productsEndSoon = response.data.data.itemsEndSoon;
              this.filter.categories = response.data.data.categories;


              if (response.data.data.items.length > 0) {
                this.page += 1;
                this.products.push(...response.data.data.items);
                $state.loaded();
              } else {
                $state.complete();
              }
            }
          })
          .catch(error => {
            this.$Progress.finish();
          })
    },

  },
  created() {
    this.getStockGroups();

    if (!this.$route.query.categoryIds) {
      this.getStocks();
    }
  },
  mounted() {
    if (this.$route.query.categoryIds) {
      this.filter.categoryIds = (Array.isArray(this.$route.query.categoryIds) ? this.$route.query.categoryIds : [this.$route.query.categoryIds]);
    }

    if (this.$route.query.categoryIds) {
      this.getStocks();
    }
  }
}
</script>

<style scoped>

</style>